export default __webpack_public_path__ + "static/media/b4.bd4993b9.png";